import React from 'react';
import { styled } from '@mui/material/styles';
import UploadFile from '@mui/icons-material/UploadFile';
import ButtonComponent from "components/Button";

const Input = styled('input')({
    display: 'none',
});

const FileVideoButton = ({onFileSelect, idx}) => {

    return (
        <label htmlFor={`contained-button-file-${idx}`}>
            <Input accept="video/*" id={`contained-button-file-${idx}`} type="file" onChange={onFileSelect} />
            <ButtonComponent
                sx={{
                    m: 2,
                    color: 'text.lightprimary',
                }}
                endIcon={<UploadFile />}
                type="primary"
                variant="contained"
                size="small"
                name="Video"
                component="span"
            />
        </label>
    )
}


export default FileVideoButton;
